import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Smartphone, X, Share } from "lucide-react";
import { useInstallPrompt } from "@/lib/installPrompt";

/** Floating "Add Dr.Gadget to your home screen" card — shows from the 2nd visit; /ask has its own inline banner. */
export function InstallPrompt() {
  const { available, ios, install, dismiss } = useInstallPrompt();
  const [returning, setReturning] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const visits = Number(localStorage.getItem("dg_visits") || 0) + 1;
    localStorage.setItem("dg_visits", String(visits));
    setReturning(visits >= 2);
  }, []);

  if (!available || !returning || pathname.startsWith("/ask") || pathname.startsWith("/admin")) return null;
  return (
    <div className="md:hidden fixed left-3 right-3 bottom-[88px] z-40 rounded-2xl border border-[#FFD600]/40 bg-[#0B1120]/95 backdrop-blur-md p-4 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.8)]" data-testid="install-prompt">
      <button type="button" onClick={dismiss} className="absolute top-2 right-2 w-10 h-10 grid place-items-center text-slate-400" aria-label="Dismiss" data-testid="install-dismiss"><X className="w-4 h-4" /></button>
      <div className="flex items-start gap-3 pr-8">
        <img src="/icon-192.png" alt="" className="w-12 h-12 rounded-xl shrink-0" />
        <div className="text-sm">
          <div className="font-display font-semibold text-white">Keep Dr.Gadget one tap away</div>
          {ios
            ? <p className="text-slate-400 mt-1" data-testid="install-ios-steps">Tap <Share className="inline w-3.5 h-3.5 -mt-0.5 text-cyan-300" /> <strong className="text-slate-200">Share</strong>, then <strong className="text-slate-200">Add to Home Screen</strong> — book, ask or call David from your home screen.</p>
            : <p className="text-slate-400 mt-1">Add the app icon to your home screen — book, ask or call David in one tap.</p>}
          {!ios && (
            <button type="button" onClick={install} className="dg-btn-primary rounded-full px-4 py-2.5 min-h-[44px] text-sm mt-3 inline-flex items-center gap-2" data-testid="install-btn">
              <Smartphone className="w-4 h-4" /> Add to home screen
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
